import * as Yup from 'yup'

export const verifyCodePhoneSchema = Yup.object().shape({
  code: Yup.string().required('Campo obrigatório').min(5, 'O código deve ter 5 dígitos'),
})
